import React from 'react';
import PropTypes from 'prop-types';

export const SvgEye = ({ width, height, stroke }) => (
  <svg width={width ?? '17px'} height={height ?? '14px'} viewBox="0 0 17 14" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g
        transform="translate(-305.000000, -4145.000000)"
        stroke={stroke ?? '#000000'}
        strokeWidth="2"
      >
        <g transform="translate(268.000000, 3660.000000)">
          <g transform="translate(25.000000, 472.000000)">
            <g transform="translate(8.229167, 8.000000)">
              <path d="M4.66666667,12 C4.66666667,12 7.33333333,6.66666667 12,6.66666667 C16.6666667,6.66666667 19.3333333,12 19.3333333,12 C19.3333333,12 16.6666667,17.3333333 12,17.3333333 C7.33333333,17.3333333 4.66666667,12 4.66666667,12 Z M12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgEye.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};
